import PropTypes from 'prop-types';
import React from 'react';
import UnderlineNavigation from '../../../components/Elements/UnderlineNavigation/UnderlineNavigation';
import PageNav from '../../../components/JobComponents/Pagination/PageNav/PageNav';
import Layout from '../../../components/Layout/Layout';
import LeftRailContent from '../../../components/LeftRailLayout/LeftRailContent/LeftRailContent';
import LeftRailLayout from '../../../components/LeftRailLayout/LeftRailLayout';
import { ATTRIBUTION_MODE_CHERRYPICK } from '../../../contexts/AbstractContext';
import UnifiedPostCard from '../../../components/UnifiedPostCard/UnifiedPostCard';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';
import {
    FETCH_MODE_NONE,
    Provider as CommunityContextProvider,
} from '../../../contexts/CommunityContext';
import { PAGE_PROPS } from '../../defaultProps';
import './ResourceContent.scss';

const ResourceContent = (props) => {
    return (
        <div className="page-Resource-ResourceContent">
            <SnowplowPageViewTracker
                pageSection={PAGE_VIEW_SECTIONS.ADVICE_LANDING}
                pageType={PAGE_VIEW_TYPES.COLLECTION}
            />
            <Layout PAGE_PROPS={props.PAGE_PROPS}>
                <CommunityContextProvider
                    fetchMode={FETCH_MODE_NONE}
                    attributionMode={ATTRIBUTION_MODE_CHERRYPICK}
                    content={props.contents}
                    page={props.pagination.page}
                >
                    <LeftRailLayout>
                        <LeftRailLayout.LeftRail>
                            <LeftRailContent {...props.PAGE_PROPS.leftRail} />
                        </LeftRailLayout.LeftRail>
                        <LeftRailLayout.MainContent>
                            <div className="titleSection">
                                <div className="pageTitle">
                                    Content & Advice
                                </div>
                            </div>
                            <div className="mb-3">
                                <UnderlineNavigation
                                    menuItems={props.menuItems}
                                />
                            </div>
                            {props.contents.map((content, index) => (
                                <UnifiedPostCard
                                    key={content.hash}
                                    index={props.pagination.page * 10 + index}
                                    {...content}
                                    location="resources-content"
                                />
                            ))}
                            <PageNav
                                prevUrl={props.pagination.prevUrl}
                                nextUrl={props.pagination.nextUrl}
                            />
                        </LeftRailLayout.MainContent>
                    </LeftRailLayout>
                </CommunityContextProvider>
            </Layout>
        </div>
    );
};

ResourceContent.defaultProps = {
    PAGE_PROPS: { url: { path: '/' } },
    pagination: null,
    menuItems: [],
};

ResourceContent.propTypes = {
    /**
     * Global props from the server
     */
    PAGE_PROPS,
    contents: PropTypes.arrayOf(PropTypes.object).isRequired,
    pagination: PropTypes.shape({
        prevUrl: PropTypes.string,
        nextUrl: PropTypes.string,
        page: PropTypes.number,
    }),
    menuItems: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
            active: PropTypes.bool,
        })
    ),
    userStatusOfCompleteness: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ResourceContent;
